import { BaseFrameworkError } from "@bloglovin/vue-framework";

class SelectionBreakpointInvariantError extends BaseFrameworkError {}

export default SelectionBreakpointInvariantError;
